import { GenericNameSlugAttribute } from "./reporting-display-column";

export interface StateNameSlugAttribute extends GenericNameSlugAttribute {}

// These are used for display purposes sometimes so try to keep them in alphabetical order
export const SUPPORTED_STATES : StateNameSlugAttribute[] = [
  { slug: 'AL', name: 'Alabama' },
  { slug: 'AZ', name: 'Arizona' },
  { slug: 'CA', name: 'California' },
  { slug: 'CO', name: 'Colorado' },
  { slug: 'DC', name: 'Washington D.C.' },
  { slug: 'DE', name: 'Delaware' },
  { slug: 'FL', name: 'Florida' },
  { slug: 'GA', name: 'Georgia' },
  { slug: 'LA', name: 'Louisiana' },
  { slug: 'MD', name: 'Maryland' },
  { slug: 'MO', name: 'Missouri' },
  { slug: 'IL', name: 'Illinois' },
  { slug: 'IN', name: 'Indiana' },
  { slug: 'NJ', name: 'New Jersey' },
  { slug: 'NM', name: 'New Mexico' },
  { slug: 'NC', name: 'North Carolina' },
  { slug: 'PA', name: 'Pennsylvania' },
  { slug: 'SC', name: 'South Carolina' },
  { slug: 'TN', name: 'Tennessee' },
  { slug: 'TX', name: 'Texas' },
  { slug: 'VA', name: 'Virginia' },
  { slug: 'WA', name: 'Washington' },
];

export const SUPPORTED_STATE_POSTAL_CODES = SUPPORTED_STATES.map(state => state.slug);

// Useful during intergration period, remove when no longer relevant
export const TRELORA_STATE_POSTAL_CODES = [
  'AZ',
  'CA',
  'CO',
  'GA',
  'NC',
  'SC',
  'WA',
  'NM',
  'TX',
  'TN',
  'LA',
  'AL',
  'MO',
  'IL',
  'IN',
]


export const ALL_STATE_POSTAL_CODES = [
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
]
